export default {
    onEvent: function onEvent(event) {
        var category = event.category,
            eventName = event.eventName;

        var timestamp = new Date().toString();
        var key = 'gw-events-' + timestamp + '-' + category + '-' + eventName;
        try {
            localStorage.setItem(key, JSON.stringify(event));
        } catch (error) {
            console.error('Local storage event store error');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-js/adapters/LocalstorageAdapter.js
// module id = 921
// module chunks = 0